import type { RouteRecordRaw } from "vue-router";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import {
  PATH_ABOUT,
  PATH_ABOUT_ADMINISTRATION,
} from "~/modules/about/constants";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_ABOUT,
    component: () => import("~/modules/about/views/AboutPage.vue"),
    meta: {
      breadcrumb: BREADCRUMBS.ABOUT,
    },
  },
  {
    path: PATH_ABOUT_ADMINISTRATION,
    component: () => import("~/modules/about/views/AboutPage.vue"),
    meta: {
      breadcrumb: BREADCRUMBS.ABOUT,
      layout: "AdministrationLayout",
    },
  },
];

export default routes;
